export default __webpack_public_path__ + "10839c81d4638f8e5828ef6ae55e70a7.svg";